import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { Box } from 'ui/acro'

import { useNavbarContext } from '../../../common/data/_store'

import NotificationBadge from './NotificationBadge'
import ProfileMenu from './ProfileMenu'
import { ProfileIcon } from '../../../../../../Icons'
import DropdownMenu from '../../../common/DropdownMenu'
import { useUserContext } from 'context'
import ReferralShareModal from 'components_v2/Referral/ReferralShareModal'

const Container = styled(Box)((props) => ({
  marginBottom: '-15px',
  paddingBottom: '15px',
  '> svg': {
    stroke: props.theme.colors.white
  }
}))

const Profile = ({ color = 'white' }) => {
  const { state } = useNavbarContext()
  const { user } = useUserContext()
  const [isHovered, setHovered] = useState(false)
  const [showReferral, setShowReferral] = useState(false)

  useEffect(() => {
    const handleUrlChange = () => {
      setHovered(false)
    }
    window.addEventListener('locationchange', handleUrlChange)
    return () => {
      window.removeEventListener('locationchange', handleUrlChange)
    }
  }, [])

  return (
    // TODO: make this accessible via keyboard navigation
    // (Currently only works through mouse navigation)
    <div style={{ position: 'relative' }}>
      <Container
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label='Profile Menu'
        aria-haspopup='true'
        aria-expanded={isHovered}
        color={color}
      >
        <ProfileIcon isHovered={isHovered} />
        <DropdownMenu isHovered={isHovered} mt='12px' right='0'>
          <ProfileMenu onShowReferral={() => setShowReferral(true)} />
        </DropdownMenu>
      </Container>
      {state.notificationCount > 0 && (
        <NotificationBadge position='absolute' top='-6px' right='-9px' />
      )}
      {user && user.id && (
        <ReferralShareModal
          show={showReferral}
          onHide={() => setShowReferral(false)}
          userId={user.id}
          entryPoint='profile_menu'
        />
      )}
    </div>
  )
}

export default Profile
